import React from "react";

// Kept Property Management brand lockup.
// The rounded badge is intentionally omitted so the mark sits directly on
// the surrounding page colour, per brand guideline "wordmark + icon on brand surface".
// - light=false (default): brass K + ink KEPT + stone descriptor  → use on Ivory
// - light=true:            brass K + ivory KEPT + brass descriptor → use on Ink
export const Logo = ({ light = false, className = "", size = 40 }) => {
  const wordColor = light ? "#F6F2EA" : "#14181C";
  const descColor = light ? "#C9A566" : "#8A8F94";
  const iconSize = size;

  return (
    <span
      className={`inline-flex items-center gap-3 ${className}`}
      style={{ lineHeight: 1 }}
      data-testid="kept-logo"
    >
      <img
        src="/brand/k-icon-brass.png"
        alt=""
        aria-hidden="true"
        style={{ height: iconSize, width: iconSize, display: "block" }}
      />
      <span className="inline-flex flex-col justify-center" style={{ gap: iconSize * 0.06 }}>
        <span
          className="font-serif"
          style={{
            fontWeight: 700,
            fontSize: iconSize * 0.62,
            letterSpacing: "0.02em",
            color: wordColor,
            lineHeight: 1,
          }}
        >
          KEPT
        </span>
        <span
          className="font-sans"
          style={{
            fontWeight: 500,
            fontSize: iconSize * 0.2,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: descColor,
            lineHeight: 1,
          }}
        >
          Property Management
        </span>
      </span>
      <span className="sr-only">Kept Property Management</span>
    </span>
  );
};

export default Logo;
